// 调节滑块——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `module/slider/index${i + 1}`,
  name: `module/sliderIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/slider/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 调节滑块——主流程，开始
    ...MainRoutes
  ]
}
